import { Nav } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'

function PageHeader(props) {
  const { headerTitle, isTabShow, renderRight, showBackButton = false } = props
  const history = useHistory()

  return (
    <div className="row align-items-center">
      <div className="border-0 mb-2">
        <div className="card-header no-bg bg-transparent d-flex align-items-center px-0 justify-content-between flex-wrap">
          <div className="d-flex align-items-center gap-2">
            {showBackButton ? (
              <i
                className="icofont-arrow-left"
                style={{ fontSize: 30, cursor: 'pointer' }}
                onClick={() => history.goBack()}
              ></i>
            ) : null}
            <h3 className="fw-bold mb-0 py-3">{headerTitle}</h3>
          </div>
          {isTabShow ? (
            <div className="col-auto py-2 w-sm-100">
              <Nav
                className="nav nav-tabs tab-body-header rounded invoice-set"
                variant="pills"
              >
                <Nav.Item>
                  <Nav.Link eventKey="Invoice List">Invoice List</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="Simple invoice">Simple invoice</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="Email invoice">Email invoice</Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
          ) : null}
          {renderRight ? renderRight() : null}
        </div>
      </div>
    </div>
  )
}

export default PageHeader
